/*! hash:06b0d4e8a9e4ea1bc02d, chunkhash:a6d8fbcdd709cd0cd3d3, name:solutionVehicle/index, filebase:index.a6d8fbcdd.js, query:, file:static/js/solutionVehicle/index.a6d8fbcdd.js */
webpackJsonp([3],{

/***/ 16:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

__webpack_require__(1);

__webpack_require__(16);

__webpack_require__(2);

$(function () {
  $(window).resize(function () {
    Affix();
  });
  hoverCss();
  Affix();
  wayPoint();
});

function hoverCss() {
  $('.solution-wrapper').find('.value-item').hover(function () {
    $(this).addClass('active');
  }, function () {
    $(this).removeClass('active');
  });
}
function wayPoint() {
  $('.page').waypoint(function (direction) {
    if (direction === 'down') {
      $(this.element).find('.state').addClass('animated slideInUp');
    }
  }, { offset: '70%' });
}
function Affix() {
  var affixTop = $(".solution-wrapper .offsetTop").offset().top;
  $('#affixBox').affix({
    offset: {
      top: affixTop
    }
  });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ })

},[32]);


// WEBPACK FOOTER //
// static/js/solutionVehicle/index.a6d8fbcdd.js